export function DrawdownPreviewEmptyState() {
  return (
    <div className="rounded-lg border p-6">
      <h2 className="text-xl font-semibold">No Batches Found</h2>
      <p className="text-sm text-muted-foreground mt-2">
        This drawdown does not have any batches yet.
      </p>
    </div>
  );
}
